import React from 'react';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import SkeletonBody from '@afosto/components-react/SkeletonBody';

const HandlingListItemSkeleton = () => (
  <Grid item xs={12}>
    <Card>
      <Box display="flex" flexWrap="nowrap" alignItems="center">
        <Box flexGrow={1}>
          <CardContent>
            <SkeletonBody lines={2} />
            <Box mt={2}>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <SkeletonBody lines={1} />
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Box>
      </Box>
    </Card>
  </Grid>
);

export default HandlingListItemSkeleton;
